export function getAppConfigurations() {
  const {
    REACT_APP_SSO_CLIENT_ID,
    REACT_APP_SSO_AUTH_DOMAIN,
    REACT_APP_ROOT_DOMAIN,
    REACT_APP_DOMAIN_URL,
    REACT_APP_MAIN_API_ENDPOINT,
    REACT_APP_PROFILE_API_ENDPOINT,
    REACT_APP_PINGPONG_API_ENDPOINT,
    REACT_APP_COURSES_URL,
    REACT_APP_VERSION,
    REACT_APP_ENVIRONMENT,
    REACT_APP_ALL_ADVISORS_URL,
    REACT_APP_TAG_ID,
  } = process.env;

  return {
    cognitoClientId: REACT_APP_SSO_CLIENT_ID,
    cognitoAuthDomain: REACT_APP_SSO_AUTH_DOMAIN,
    rootDomain: REACT_APP_ROOT_DOMAIN,
    domainUrl: REACT_APP_DOMAIN_URL,
    mainApiEndpoint: REACT_APP_MAIN_API_ENDPOINT,
    profileApiEndpoint: REACT_APP_PROFILE_API_ENDPOINT,
    pingpongApiEndpoint: REACT_APP_PINGPONG_API_ENDPOINT,
    myCoursesUrl: REACT_APP_COURSES_URL,
    allAdvisorsUrl: REACT_APP_ALL_ADVISORS_URL,
    environment: REACT_APP_ENVIRONMENT || 'local',
    appVersion: REACT_APP_VERSION,
    gaMeasurementId: REACT_APP_TAG_ID,
  };
}
